import { render, staticRenderFns } from "./DiskMe.vue?vue&type=template&id=837b2cf8&scoped=true"
import script from "./DiskMe.vue?vue&type=script&lang=js"
export * from "./DiskMe.vue?vue&type=script&lang=js"
import style0 from "./DiskMe.vue?vue&type=style&index=0&id=837b2cf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837b2cf8",
  null
  
)

export default component.exports